export default __webpack_public_path__ + "static/media/330_dummy2016-massagestudio01-de.9c0c2679.png";